export default __webpack_public_path__ + "static/media/carousel-2.0f6d6f02.png";